export enum MediaStatus {
  INVALID = 'INVALID',
  PROCESSED = 'PROCESSED',
  IN_PROCESS = 'IN_PROCESS',
}
